import { createAsyncThunk } from '@reduxjs/toolkit';
import { closeChat, openChat, openErrorMessage, setChatLoading } from '../../slices/consultantCianChat';
import { onOpenChatPopup } from '../../containers/ConsultantChatButtonContainer/analytics/analytics';
import { TChatRole } from '../../repositories/newbuilding-consultants/entities/chat_user/ChatUser';
import { TSourcePage } from '../../repositories/newbuilding-consultants/entities/get_or_create_chat/PublicV1GetOrCreateChatRequest';
import { getRegionId } from '../../selectors/newbuilding';
import { getFullUrl } from '../../selectors/path';
import { getGaLabel } from '../../selectors/analytics';
import { fetchConsultantCianChat } from '../../services/fetchConsultantCianChat/fetchConsultantCianChat';
import { IThunkApi, TDispatch } from '../../types/redux';
import { getIsAuthenticated } from '../../selectors/user';
// oxlint-disable-next-line cian-eslint-compat/no-restricted-paths
import { getUserAction } from '../../../browser/services/user/getUserAction';

export const onConsultantCianCloseNoAuth = (): ((dispatch: TDispatch) => void) => {
  return (dispatch: TDispatch) => {
    dispatch(closeChat());
  };
};

export const requestChat = createAsyncThunk<void, void, IThunkApi>(
  'consultantCianChat/requestChat',
  async (_, thunkApi) => {
    const {
      dispatch,
      getState,
      extra: { httpApi, logger },
    } = thunkApi;

    try {
      dispatch(setChatLoading());

      const state = getState();
      const customLabel = getGaLabel(state);
      const regionId = getRegionId(state);
      const fullUrl = getFullUrl(state);

      const isAuthenticated = getIsAuthenticated(state);

      if (!isAuthenticated) {
        await dispatch(getUserAction());
      }

      const data = await fetchConsultantCianChat({
        httpApi,
        logger,
        parameters: { pageUrl: fullUrl, sourcePage: 'newbuildingCard' as TSourcePage },
      });

      /* istanbul ignore else */
      if (data && data.chatId) {
        const users = data.users || [];
        const user = users.find((user: { chatRole: TChatRole }) => user.chatRole === 'initiator');
        dispatch(openChat(data.chatId));
        onOpenChatPopup({ customPageURL: customLabel, chatId: data.chatId, botId: 3, ownerId: user?.userId, regionId });
      } else {
        dispatch(openErrorMessage());
      }
    } catch (error) {
      logger.error(error, {
        domain: 'requestChat',
      });
      dispatch(openErrorMessage());
    }
  },
);
